import React from 'react';
import styled from 'styled-components';
import { Modal, Button } from '@cityelectricalfactors/ui-components';
import { EmailIcon, StoreIcon, CloseXmark } from 'assets/common_svgs';
import StoreAddressBox from '../product_show/store_address_box';

import {
  grey70,
  grey5,
  white,
  cefGreen,
} from '../../../assets/stylesheets/v2/abstracts/_variables.scss';
/**
 * @param {Object} props
 * @param {function} props.catalogue - current Product catalogue number
 * @param {boolean} props.selectAStoreUrl - URL for select a store page
 * @param {function} props.currentProductName - current Product Name
 * @param {boolean} props.modalIsOpen - whether the modal is open or not
 * @param {function} props.closeModal - function to close modal
 * @param {function} props.currentStore - current Store if present
 * @returns Product store modal for renewables product
 */
const ProductStoreModal = ({
  catalogue,
  selectAStoreUrl,
  currentProductName,
  modalIsOpen,
  closeModal,
  currentStore,
  currentStore: { Email: email },
}) => (
  <StyledModal
    isOpen={modalIsOpen}
    closeModal={closeModal}
    config={{ backdropColour: 'rgba(76, 76, 76, 0.9)' }}>
    <CloseButton aria-label="close modal" handleClick={closeModal}>
      <CloseXmark />
    </CloseButton>
    <div className="fl ai-c">
      <StoreIcon width={30} height={30} fillColour={grey70} />
      <h2 className="ml-4 fw-700 ff-rc fs-22 mb-0">Contact Store to Order</h2>
    </div>
    <ModalContent>
      <ModalContentDivider className="pb-20 mb-20">
        <p className="fs-16 nm ta-l">
          This product requires special delivery. Please call, email or visit
          your local store to place an order.
        </p>
      </ModalContentDivider>
      <StoreAddressBox
        catalogue={catalogue}
        currentProductName={currentProductName}
        currentStore={currentStore}
        selectAStoreUrl={selectAStoreUrl}
        showTelephoneLink
        emailIconWidth={14}
        emailIconHeight={8}
      />
    </ModalContent>
    <ModalFooter>
      <div className="fl jc-sb m-jc-fe">
        <CloseButtonDesktop
          className="cef-btn cef-btn--med m-ml-16 fw-700 cef-btn--grey"
          handleClick={closeModal}>
          Cancel
        </CloseButtonDesktop>
        <EmailStoreLink
          href={`mailto:${email}?subject=Enquiry - ${currentProductName} - ${catalogue}`}
          target="_blank"
          rel="noopener noreferrer"
          className="cef-btn m-ml-16 fw-700">
          <EmailIcon fillColour={white} />
          <span className="ml-6">Email Store</span>
        </EmailStoreLink>
      </div>
    </ModalFooter>
  </StyledModal>
);

const StyledModal = styled(Modal)`
  > div {
    position: relative;
    box-sizing: border-box;
    max-width: 550px;
    padding: 2.5rem;
    width: 95%;
    @media screen and (min-width: 768px) {
      width: 75%;
    }
    @media screen and (min-width: 1025px) {
      width: 50%;
    }
  }
`;
const ModalContentDivider = styled.div`
  border-bottom: 1px solid ${grey5};
`;
const ModalContent = styled.div`
  @media screen and (min-width: 768px) {
    margin-left: 2rem;
  }
`;
const ModalFooter = styled.div`
  padding-top: 1rem;
  border-top: 1px solid ${grey5};
  @media screen and (min-width: 768px) {
    margin-left: 2rem;
  }
`;

const CloseButton = styled(Button)`
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 0;
  background-color: transparent;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

const CloseButtonDesktop = styled(Button)`
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
  }
`;

const EmailStoreLink = styled.a`
  background-color: ${grey70};
  min-width: 100%;
  @media screen and (min-width: 768px) {
    display: flex;
    min-width: 180px;
    background-color: ${cefGreen};
  }
`;

export default ProductStoreModal;
